import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

const IconContainer = styled.div<{ customWidth?: string; customWidthXxs?: string }>`
  > div {
    max-width: ${({ customWidth }) => (customWidth ? customWidth : '24px')};

    @media screen and (max-width: ${layout.xxs}) {
      max-width: ${({ customWidthXxs }) => (customWidthXxs ? customWidthXxs : '17px')};
    }
  }
`;

export default function IconsInstagram({
  customWidth,
  customWidthXxs,
}: {
  customWidth?: string;
  customWidthXxs?: string;
}): JSX.Element {
  const logoImage: any = useStaticQuery(graphql`
    {
      contentfulAsset(contentful_id: { eq: "7BAHsfyFaeUlka6g5BKxRd" }) {
        gatsbyImageData(width: 350, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  return (
    <IconContainer
      customWidth={customWidth}
      customWidthXxs={customWidthXxs}
    >
      <GatsbyImage
        image={logoImage.contentfulAsset.gatsbyImageData}
        alt='Instagram Icon'
      />
    </IconContainer>
  );
}
